import { FormLabel } from '@chakra-ui/react';
import { IconCircleInfo } from 'central-icons/IconCircleInfo';
import type { ReactNode } from 'react';

import { Badge, RevelioTooltip } from '@revelio/ui';

import styles from '../preference-editors/preference-editors.module.css';
import layoutStyles from './preference-editor-section-heading.module.css';

export const PreferenceEditorSectionHeading = ({
  title,
  tooltip,
  indicateDiff,
  action,
}: {
  title: string;
  tooltip?: string;
  indicateDiff: boolean;
  /** Optional control rendered at the right of the heading row. */
  action?: ReactNode;
}) => {
  return (
    <div className={layoutStyles.wrapper}>
      <div className={layoutStyles.titleRow}>
        <div className={layoutStyles.titleGroup}>
          <FormLabel
            className={styles.sectionHeading}
            fontSize="sm"
            fontWeight="semibold"
            mb={0}
            mr={0}
          >
            {title}
          </FormLabel>
          {tooltip && (
            <RevelioTooltip label={tooltip} placement="right">
              <div>
                <IconCircleInfo size={16} cursor="pointer" />
              </div>
            </RevelioTooltip>
          )}
        </div>

        <div className={layoutStyles.actions}>
          {action}
          {indicateDiff && (
            <div className={layoutStyles.diffIndicator}>
              <Badge size="sm" className={styles.sectionDiffIndicator} />
            </div>
          )}
        </div>
      </div>
    </div>
  );
};
